import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a679e48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info color-info" }
const _hoisted_2 = { class: "time" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "fs14" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Qの変更 ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, "変更内容", -1))
const _hoisted_7 = { class: "fs14" }
const _hoisted_8 = { class: "before-content" }
const _hoisted_9 = { class: "after-content" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "fs14" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 回答の変更 ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, "変更内容", -1))
const _hoisted_14 = { class: "fs14" }
const _hoisted_15 = { class: "before-content" }
const _hoisted_16 = { class: "after-content" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "fs14" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" カテゴリの変更 ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-success" }, "変更内容", -1))
const _hoisted_21 = { class: "fs14" }
const _hoisted_22 = { class: "before-content" }
const _hoisted_23 = { class: "after-content" }

import { ref } from "vue";
import { QuestionHistoryContentUpdate } from "@/types/question_history_content_update";


interface Props {
  history: QuestionHistoryContentUpdate;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    history: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
  history: QuestionHistoryContentUpdate;
}
let bodyView = ref(false);
let answerView = ref(false);
let questionCategoryView = ref(false)


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString(__props.history.user_name) + " ", 1),
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.history.post_at), 1)
    ]),
    (__props.history.content.body)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(bodyView) //@ts-ignore
 ? bodyView.value = !_unref(bodyView) : bodyView = !_unref(bodyView))),
              type: "text"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(__props.history.content.body[0]), 1),
            _createElementVNode("div", _hoisted_9, "→" + _toDisplayString(__props.history.content.body[1]), 1)
          ], 512), [
            [_vShow, _unref(bodyView)]
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.history.content.answer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(answerView) //@ts-ignore
 ? answerView.value = !_unref(answerView) : answerView = !_unref(answerView))),
              type: "text"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(__props.history.content.answer[0]), 1),
            _createElementVNode("div", _hoisted_16, "→" + _toDisplayString(__props.history.content.answer[1]), 1)
          ], 512), [
            [_vShow, _unref(answerView)]
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.history.content.question_category)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(questionCategoryView) //@ts-ignore
 ? questionCategoryView.value = !_unref(questionCategoryView) : questionCategoryView = !_unref(questionCategoryView))),
              type: "text"
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(__props.history.content.question_category[0]), 1),
            _createElementVNode("div", _hoisted_23, "→" + _toDisplayString(__props.history.content.question_category[1]), 1)
          ], 512), [
            [_vShow, _unref(questionCategoryView)]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})